import xlsx from 'json-as-xlsx';
import csvDownload from 'json-to-csv-export';

export function formatAMPM(date) {
  if (date) {
    date = new Date(date);
    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  } else {
    return '0';
  }
}

export function getItemNameOrderDetailsCard (item) {
	return item?.itemname && item?.itemname.length > 25 ? `${item?.itemname.substr(0, 25)}\u2026` : item?.itemname;
};

export function getStatusColor (item) {
	const status = item?.storeHourStatus || '';
	if (item?.isDisabled === true && item?.isOffline === true) {
		return 'grey';
	} else if (item?.isDisabled === true && item?.isOffline === false) {
		return 'grey';
	} else if (item?.isDisabled === false && item?.isOffline === true) {
	return 'red';
	} else if (item?.isDisabled === false && item?.isOffline === false && status.includes('Accepting')) {
			return '#007350';
	} else if (item?.isDisabled === false && item?.isOffline === false && status.includes('closed')) {
			return 'red';
	} else return 'red';
};

export function getItemName (item) {
	let nameValue = `${item.name.length>25? item.name.substr(0,25).trim() + '\u2026' : item.name}`;
	nameValue = nameValue+` (${item.sourceId})`;
	return nameValue
};

export function formatWithoutOffsetAMPM(date) {
  if (date) {
    date = new Date(date);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  } else {
    return '0';
  }
}

export function formatMonth(date) {
  if (date) {
    const options = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    options.timeZone = 'UTC';
    date = new Date(date).toLocaleString('en-US', options);
    return date;
  } else {
    return 'M, D YYYY';
  }
}

export function updateTimeOffset(storeUUID, storeOffsetMap, Obj, key) {
  const offsetHours = parseInt(storeOffsetMap[storeUUID], 10);
  let adjustedOrderDate = Obj[key];
  if (!isNaN(offsetHours)) {
    const orderDateTime = new Date(Obj[key]);
    const timezoneAdjustedDate = new Date(orderDateTime.setHours(orderDateTime.getHours() + offsetHours));
    adjustedOrderDate = timezoneAdjustedDate.toISOString();
  }
  //Obj[key] = String(adjustedOrderDate);
  return { ...Obj, [key]: String(adjustedOrderDate) };
}

export function generateDownload(dataValue, type, globalStartDate, globalEndDate, downloadName) {
  if (dataValue[0]) {
    let headerValue = Object.keys(dataValue[0]);
    if (type && type[0] && type[0].label === 'Spreadsheet (CSV)') {
      const dataToConvert = {
        data: dataValue,
        filename: downloadName + '_report ' + globalStartDate + '--' + globalEndDate,
        delimiter: ',',
        headers: headerValue,
      };
      csvDownload(dataToConvert);
    } else if (type && type[0] && type[0].label === 'Spreadsheet (XLS/XLSX)') {
      let data = [
        {
          sheet: 'Merchant Portal Report',
          columns: headerValue.map((hr, index) => ({ label: hr, value: hr })),
          content: [...dataValue],
        },
      ];
      let settings = {
        fileName: downloadName + '_report ' + globalStartDate + '--' + globalEndDate,
        extraLength: 3,
        writeMode: 'writeFile',
        writeOptions: {},
        RTL: false,
      };

      xlsx(data, settings);
    }
  }
}

export function formatOrderData(dataValue) {
  return dataValue?.orders?.content.map((dt) => {
    let obj = {};
    const adDate = dateWithOffset(dataValue, dt, 'orderDate');
    obj['Order ID'] = dt['merchantOrderId'] ? dt['merchantOrderId'] : '';
    obj['Status'] = dt['orderStatus'];
    obj['Date'] = formatDate(adDate);
    obj['Time'] = formatWithoutOffsetAMPM(adDate);
    obj['Store Details'] = dt['storeDetails'];
    obj['Subtotal'] = '$' + dt['orderSubTotal'];
    return obj;
  });
}

export function formatPayoutData(dataValue) {
  return dataValue?.merchantPayoutList?.content.map((dt) => {
    let obj = {};
    const adDate = dateWithOffset(dataValue, dt, 'payoutDate');
    obj['Date'] = formatDate(adDate);
    obj['Store Name'] = dt['storeName'];
    obj['Store ID'] = dt['storeID'];
    obj['Payout'] = '$' + dt['storePayoutPerDate'];
    obj['Fees'] = '$' + dt['storeCommissionPerDate'];
    obj['Paid To'] = dt['stripeDestAccountId'];
    return obj;
  });
}

export function formatPayoutByOrderData(dataValue) {
  return dataValue?.orders?.content.map((dt) => {
    let obj = {};
    const adDate = dateWithOffset(dataValue, dt, 'orderDate');
    obj['Date'] = formatDate(adDate);
    obj['Order ID'] = dt['merchantOrderId'] ? dt['merchantOrderId'] : '';
    obj['Status'] = dt['orderStatus'];
    obj['Store ID'] = dt['storeID'];
    obj['Subtotal'] = '$' + dt['orderSubTotal'];
    obj['Fees'] = '$' + dt['commission'];
    obj['Tax'] = '$' + dt['taxes'];
    obj['Payout'] = '$' + dt['netPayOut'];
    return obj;
  });
}

export function dateWithOffset(dataValue, dt, attr) {
  const offsetHours = parseInt(dataValue?.storeOffsetMap ? dataValue?.storeOffsetMap[dt?.storeUUID] : '', 10);
  let adjustedDate = dt[attr];
  if (!isNaN(offsetHours)) {
    const orderDateTime = new Date(dt.orderDate);
    const timezoneAdjustedDate = new Date(orderDateTime.setHours(orderDateTime.getHours() + offsetHours));
    adjustedDate = timezoneAdjustedDate.toISOString();
  }

  return adjustedDate;
}

// Helper functions for formatting
const formatDate = (isoDateString) => {
  if (!isoDateString) return '';
  const date = new Date(isoDateString);
  return date.toLocaleDateString();
};

export  function finalformatDate(inputDate) {
	const date = new Date(inputDate);
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const year = date.getFullYear();
	return `${month}/${day}/${year}`;
}

// Helper functions for Sorting all data in the data table
export const handleSortingInTable = (columnKey, sortConfig, setSortConfig) => {
  let direction = 'Ascending';
  if (sortConfig.key === columnKey && sortConfig.direction === 'Ascending') {
    direction = 'Descending';
  }
  setSortConfig({ key: columnKey, direction });
};

// Helper functions to convert 24hour format to 12hour and add AM or PM
export const convertTo12HourFormat = (time24) => {
  const [hours, minutes] = time24.split(':').map(Number);
  if (hours === 24 && minutes === 0) {
    // Handle the special case of 24:00
    return `12:00AM`;
  }
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const adjustedHours = hours % 12 || 12;
  return `${adjustedHours}:${minutes.toString().padStart(2, '0')}${suffix}`;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0) !== string.charAt(0).toUpperCase() ? string.charAt(0).toUpperCase() + string.slice(1) : string;
};

export const getFirstLetterCapitalized = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPhoneNumber = (phoneNumber) => {
  let cleaned = ('' + phoneNumber).replace(/\D/g, '');
  if (cleaned.length !== 11) {
    return 'Invalid number';
  }
  let country = cleaned.slice(0, 1);
  let area = cleaned.slice(1, 4);
  let middle = cleaned.slice(4, 7);
  let last = cleaned.slice(7, 11);
  return `(${area}) ${middle}-${last}`;
};

export const getTargetDate = () => {
  var targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 7);
  return targetDate.toUTCString();
};

export const getTokenTargetDate = () => {
  var now = new Date();
  var time = now.getTime();
  time += 3600 * 1000;
  now.setTime(time);
  return now;
};

export const checkPathNeedToken = (pathname) => {
    return (pathname === '/' || pathname === '/changepassword' || pathname === '/getstarted' || pathname === '/updatepassword' || pathname === '/otter' || pathname === '/iacm')
}

export const get_cookie = (name) => {
  return document.cookie.split(';').some((c) => {
    return c.trim().startsWith(name + '=');
  });
};

export const getCookie = (name) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const delete_cookie = (name, path, domain) => {
  if (get_cookie(name)) {
    document.cookie = name + '=' + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
};
export const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const validateUserName = (username) => {
  let exp = /^[A-Za-z0-9!#@%*:_^-]*$/;
  return username.split(' ').length === 1 && exp.test(username);
};

export const validateUserNameandEmail = (userinput) => {
	let exp = /^[A-Za-z0-9!#@%*.:_^-]*$/;
	return userinput.split(' ').length === 1 && exp.test(userinput);
  };

export const validateOTP = (otp) => {
  let exp = /^[0-9]*$/;
  return exp.test(otp) && otp.length === 6;
};

export const restrictOnlyFewSpecialChara = (val) => {
  let exp = /^[a-zA-Z0-9!#@%*:_^-]+$/;
  return exp.test(val);
};

export const onlySpecialCharaAllowed = (val) => {
  const exp = /[ !#@%*:_^-]/;
  const expUp = /[ A-Z]/;
  return exp.test(val) && expUp.test(val);
};

export const containsAtleastOneNumber = (val) => {
	return /\d/.test(val);
}

export const checkForRepeatedSequence = (str) => {
  let sequenceLength = 3;
  let resultFound = new Set();
  let repeatedSeq = new Set();
  let numRegEx = /[0-9]/;
  let spRegEx = /[!#@]/;
  let charCount = {};
  let rpChars = [];

  str.split('').map((s, i) => {
    const seq = str.substring(i, i + sequenceLength);

    if (resultFound.has(seq)) {
      repeatedSeq.add(seq);
    } else {
      resultFound.add(seq);
    }

    if (numRegEx.test(s) || spRegEx.test(s)) {
      if (charCount[s]) {
        charCount[s]++;
      } else {
        charCount[s] = 1;
      }
    }
  });

  for (const char in charCount) {
    if (charCount[char] > 1) {
      rpChars.push(char);
    }
  }

  return str.length > 0 && Array.from(repeatedSeq).length === 0 && rpChars.length === 0;
};

export const sanitizeFileName = (fileName) => {
	return fileName.replace(/[^a-zA-Z0-9.-]/g, '_');
};

export const sanitizeInput = (input) => {
	return input.replace(/[.;'"\/$<>`|=~&()]/g, '').replace(/--/g, '');
};

export const sanitizeEmailInput = (input) => {
	return input.replace(/[;'"\/<>`|=~&()]/g, '');
};

export const isValidEmail = (email) => {
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailPattern.test(email);
};

export const sanitizePercentageInput = (input) => {
    let sanitized = input.replace(/[^0-9%]/g, '');
    const parts = sanitized.split('%');
    if (parts.length > 3) {
        sanitized = parts[0] + '%';
    } else {
        sanitized = parts[0] + (parts.length === 2 ? '%' : '');
    }
    if (sanitized.length > 4) {
        sanitized = sanitized.slice(0, 3) + (sanitized.includes('%') ? '%' : '');
    }
    return sanitized;
};

export const isValidPercentage = (input) => {
    const percentagePattern = /^(100|[1-9]?[0-9]|[0-9]{1,2})%$/;
    return percentagePattern.test(input);
};

export const checkCookie = (showCookieFail) => {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){ 
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie')!=-1;
  }
  return cookieEnabled || showCookieFail();
}

export const handleInputChange = (value, setter, setError, isEmail = false, checkAddress = false, isPercentage = false) => {
    let sanitizedValue = value;

    if (isEmail) {
        sanitizedValue = sanitizeEmailInput(value);
    } else if (isPercentage) {
        sanitizedValue = sanitizePercentageInput(value);
    } else {
        sanitizedValue = sanitizeInput(value);
    }

    setter(sanitizedValue);

    if (setError) {
        if (isEmail) {
            setError(!isValidEmail(sanitizedValue));
        } else if (isPercentage) {
            setError(!isValidPercentage(sanitizedValue));
        } else if (checkAddress) {
            if (sanitizedValue.trim() === '') {
                setError(true);
            } else {
                setError(false);
            }
        } else {
            setError(sanitizedValue.trim() === '');
        }
    }
};
